import { Provider } from '../../../constants/shipping-grouping';
import { useUserSetting } from '../../../hooks/use-user-setting';

import useCarrierGroups from './use-carrier-groups';
import useProviderGroups from './use-provider-groups';

const useProviderOrCarrierGroups = (availableServices, selectedItem, getDisplayName) => {
  const groupByUserSetting = useUserSetting('ShippingServiceGrouping') || Provider;
  const carrierGroups = useCarrierGroups(availableServices, selectedItem);
  const providerGroups = useProviderGroups(availableServices, selectedItem, getDisplayName);
  return groupByUserSetting === Provider ? providerGroups : carrierGroups;
};

export default useProviderOrCarrierGroups;
